'use client'

import { Box, Typography } from '@mui/material'
import CheckIcon from '@mui/icons-material/Check'
import CloseIcon from '@mui/icons-material/Close'
import { Plan } from '../types'
import BenefitTooltip from './BenefitToolTip'

export default function FareBenefitRow({
    label,
    text,
    plan,
}: {
    label: string
    text: string
    plan: Plan
}) {

    return (
        <Box display="flex" alignItems="flex-start" justifyContent="space-between" textAlign="start">
            <Box display="flex" alignItems="center">
                {plan.included[label] ? (
                    <CheckIcon color="success" fontSize="small" sx={{ mr: 1 }} />
                ) : (
                    <CloseIcon color="error" fontSize="small" sx={{ mr: 1 }} />
                )}
                <Typography variant="body2">{text}</Typography>
                {(label === 'cancel' || label === 'amend') && (
                    <BenefitTooltip tooltip={plan.toolTipData[label]} />
                )}
            </Box>
        </Box>
    )
}